import { withChartLayout } from 'components/common';
import SmokingScreen from 'components/features/chart/admission-history/smoking-screen/SmokingScreen';

const SmokingScreenPage = withChartLayout('Smoking Screen')(SmokingScreen);
export default SmokingScreenPage;
